import {
  clearSrDocumentPropertyAction,
  clearSrDocumentPropertyErrors,
  updateSrDocumentProperty,
} from 'actions/srDocuments/srDocumentPropertyActions'
import SrCustomPropertyForm from 'components/common/properties/SrCustomPropertyForm'
import _ from 'lodash'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

const SrDocumentPropertyUpdate = ({
  formId,
  params,
  setParams,
  closeModal,
  selected,
}) => {
  //// HOOKS.
  const dispatch = useDispatch()

  //// GLOBAL STATE.
  const { lastAction, srDocumentPropertyErrors } = useSelector(
    (state) => state.srDocumentProperties
  )

  //// LOCAL STATE.

  //// LIFECYCLE HELPERS.

  //// MEMOS.

  //// EFFECTS.
  useEffect(() => {
    return () => {
      dispatch(clearSrDocumentPropertyAction())
      dispatch(clearSrDocumentPropertyErrors())
    }
  }, [dispatch])

  useEffect(() => {
    if (_.isEmpty(params)) {
      setParams({
        required: selected.required || false,
      })
    }
  }, [params, setParams, selected])

  useEffect(() => {
    if (lastAction === 'edit') {
      closeModal()
    }
  }, [lastAction, closeModal])

  //// RENDER VARS & HELPERS.

  //// RENDER.
  return !_.size(params) ? (
    ''
  ) : (
    <form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault()
        const updatedParams = _.mapValues(params, (prop, key) => {
          const propValue = prop !== '' && prop !== null
          const newValue = selected[key] !== prop
          if (newValue && propValue) return prop
        })
        updatedParams.id = selected.id

        const updatedProperty = _.mergeWith(selected, updatedParams)
        dispatch(updateSrDocumentProperty(updatedParams, updatedProperty))
      }}
      className="form container"
      noValidate
    >
      <SrCustomPropertyForm
        params={params}
        setParams={setParams}
        srDocumentTypeDefaultOption="All Site Readiness Types"
        errors={srDocumentPropertyErrors}
      />
    </form>
  )
}

export default SrDocumentPropertyUpdate
